'use strict';

import { difference, differenceBy, intersectionBy, isObject, pickBy } from 'lodash';


// Rules
// * null, undefined and <missing> are treated as equal
// * array contents are either primitives or objects with id

export function diff(from, to, { skipArrays = false } = {}) {
    const added = [];
    const removed = [];
    const modified = [];

    diff_('', from, to);

    return {
        added,
        removed,
        modified,
    };


    function diff_(pathPrefix, from, to) {
        try {
            if (Array.isArray(from) && Array.isArray(to)) {
                // Arrays
                if (!skipArrays) {
                    arrayDiff_(pathPrefix, from, to);
                }
            } else if (typeof from === 'object' && typeof to === 'object') {
                // Objects
                objDiff_(pathPrefix, from, to);
            } else {
                // Scalars, mixed types
                modified.push({ field: pathPrefix, from, to });
            }
        } catch (err) {
            if (err.isDiffError) {
                throw err;
            } else {
                const err2 = new Error('Diff error');

                err2.isDiffError = true;
                err2.data = { pathPrefix, a: from, b: to, cause: err };

                throw err2;
            }
        }
    }

    function arrayDiff_(pathPrefix, from, to) {
        if (isObject(from[0]) || isObject(to[0])) {
            // Object arrays
            differenceBy(to, from, 'id').forEach(o => added.push({ field: appendId(pathPrefix, o.id), value: o }));
            differenceBy(from, to, 'id').forEach(o => removed.push({ field: appendId(pathPrefix, o.id), value: o }));
            intersectionBy(from, to, 'id').forEach(o => diff_(appendId(pathPrefix, o.id), o, to.find(p => p.id === o.id)));
        } else {
            // Scalar, mixed type arrays
            difference(to, from).forEach(i => added.push({ field: `${pathPrefix}[]`, value: i }));
            difference(from, to).forEach(i => removed.push({ field: `${pathPrefix}[]`, value: i }));
        }
    }

    function objDiff_(pathPrefix, from, to) {
        for (const k of Object.keys({ ...pickBy(from, v => v != null), ...pickBy(to, v => v != null) })) {
            if (from[k] == null) {
                added.push({ field: appendField(pathPrefix, k), value: to[k] });
            } else if (to[k] == null) {
                removed.push({ field: appendField(pathPrefix, k), value: from[k] });
            } else if (to[k] !== from[k]) {
                diff_(appendField(pathPrefix, k), from[k], to[k]);
            }
        }
    }

    function appendField(pathPrefix, key) {
        return `${pathPrefix}${pathPrefix ? '.' : ''}${key}`;
    }

    function appendId(pathPrefix, id) {
        return `${pathPrefix}{${id}}`;
    }
}
